if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
      
      /* JVC: CUSTOM FOR 360 */
      let containsXML = activeMedia.alt.includes(".xml");
  	  if(containsXML === true)
  	  {
  		var altSource = activeMedia.alt;
  
  		altSource = altSource.replace("s1", "v1"); 
  	    altSource = altSource.replace("com/", "com?spin="); 

  		const lastSegment = "/" + altSource.split("/").pop();
    	altSource = altSource.replace(lastSegment, ""); 
        console.log("activeMedia.innerHTML: " + activeMedia);
  
  		var oldElement = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
  		const newItem = document.createElement("iframe");
  		newItem.setAttribute("id", "threeSixtyFrame");
    	newItem.setAttribute("class", "global-media-settings global-media-settings--no-shadow active");

 
  		newItem.src = altSource;
		oldElement.parentNode.replaceChild(newItem, oldElement);
        /*console.log("activeMedia.alt: " + activeMedia.alt);
        console.log("altSource: " + altSource);
        console.log("lastSegment: " + lastSegment);
		//activeMedia.innerHTML = altSource;
        console.log("activeMedia.innerHTML: " + activeMedia.innerHTML);*/
  		newItem.scrollIntoView();


      }
    }
  });
}
